// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"DocumentsTab_tableHeader__2-4vx","divider":"DocumentsTab_divider__2Qyet","spinner":"DocumentsTab_spinner__1aP0V"};